import React from 'react';
import { Popover, PopoverBody, PopoverHeader, Button, Table } from 'reactstrap';

export class PhaseMaterialPopover extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
        };
    }

    togglePopover = () => {
        const { show } = this.state;

        this.setState({ show: !show });
    };

    render() {
        const { associatedPhaseMaterials, heavyBidMaterials, contractPhaseId } =
            this.props;
        const { show } = this.state;

        const popoverId = `material-popover-${contractPhaseId}`;

        if (
            !associatedPhaseMaterials ||
            !associatedPhaseMaterials.length ||
            !heavyBidMaterials
        ) {
            return null;
        }

        return (
            <>
                <Button
                    color="info"
                    onClick={this.togglePopover}
                    id={popoverId}
                    outline={!show}
                >
                    {show ? 'Hide' : 'Show'} {associatedPhaseMaterials.length}{' '}
                    Materials
                </Button>

                <Popover
                    isOpen={show}
                    target={popoverId}
                    toggle={this.togglePopover}
                    placement="right"
                    fade={false}
                >
                    <PopoverHeader>Materials</PopoverHeader>
                    <PopoverBody>
                        <Table striped={true}>
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Description</th>
                                    <th>Quantity</th>
                                </tr>
                            </thead>
                            <tbody>
                                {associatedPhaseMaterials.map((apm) => {
                                    const heavyBidMaterial =
                                        heavyBidMaterials.find(
                                            (hbm) =>
                                                hbm.id == apm.heavyBidMaterialId
                                        );

                                    return (
                                        <tr key={apm.id}>
                                            <td>{heavyBidMaterial.code}</td>
                                            <td>
                                                {heavyBidMaterial.description}
                                            </td>
                                            <td>
                                                {apm.quantity}{' '}
                                                {heavyBidMaterial.unitOfMeasure}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </PopoverBody>
                </Popover>
            </>
        );
    }
}
